import React from "react";
import BrowserViewGlobal from "../../Views/BrowserView";
import MessageItem from "../MessageItem";

export default function MessageListBrowserView({ messageData, me, event }) {
  return (
    <BrowserViewGlobal className="message_list">
      {messageData.length > 0 &&
        messageData.map((messageItem) => {
          return (
            <MessageItem
              key={`announcement-${messageItem.id}`}
              messageItem={messageItem}
              me={me}
              eventSlug={event}
            />
          );
        })}
    </BrowserViewGlobal>
  );
}
